export default __webpack_public_path__ + "static/media/dashboard-white.0cfb273b.svg";